import { ApiConfigs } from "./configs.entity";

export const defaultConfig: ApiConfigs = {
  min_dialog_view: 190000,
  max_dialog_view: 1000000000,
  min_channel_view: 100,
  max_channel_view: 1000000,
  min_dialog_click: 4500,
  max_dialog_click: 1000000000,
  min_channel_click: 100,
  max_channel_click: 10000,
  ad_start_delay: 0,
  view_price: 40,
  new_view_price: 16,
  click_price: 3000,
  new_click_price: 2000,
  external_coef: 3,
  member_partition: [-1, -1],
  discount_partition: [0, 0],
  ad_start_hours: [9, 11, 13, 15, 17, 19],
  start_hours_capacity: [6, 6, 6, 4, 4, 3],
  week_days_capacity: [
    42000000,
    42000000,
    42000000,
    42000000,
    42000000,
    42000000,
    42000000,
  ],
  click_to_view_coef: 125000,
  hemayati_click_coef: 1500,
  hemayati_view_coef: 2100,
  categories: [
    {
      Id: 1,
      Title: "خدمات کسب و کار",
      Subcategory: [
        {
          Id: 101,
          Title: "مشاوره کسب و کار",
        },
        {
          Id: 102,
          Title: "املاک و عمرانی",
        },
        {
          Id: 103,
          Title: "خدمات مالی و بیمه",
        },
        {
          Id: 104,
          Title: "سایر",
        },
      ],
    },
    {
      Id: 2,
      Title: "فروشگاهی",
      Subcategory: [
        {
          Id: 201,
          Title: "آرایشی و بهداشتی",
        },
        {
          Id: 202,
          Title: "آموزشی",
        },
        {
          Id: 203,
          Title: "اسباب بازی و عروسک",
        },
        {
          Id: 204,
          Title: "پوشاک",
        },
        {
          Id: 205,
          Title: "پوشاک آقایان",
        },
        {
          Id: 206,
          Title: "پوشاک بانوان",
        },
        {
          Id: 207,
          Title: "پوشاک خانواده",
        },
        {
          Id: 208,
          Title: "پوشاک کودک و نوجوان",
        },
        {
          Id: 209,
          Title: "خانه و آشپزخانه",
        },
        {
          Id: 210,
          Title: "خوراکی و مواد غذایی",
        },
        {
          Id: 211,
          Title: "شال و روسری",
        },
        {
          Id: 212,
          Title: "فرهنگی و هنری",
        },
        {
          Id: 213,
          Title: "کتاب و لوازم تحریر",
        },
        {
          Id: 214,
          Title: "کالای دیجیتال",
        },
        {
          Id: 215,
          Title: "کیف و کفش",
        },
        {
          Id: 216,
          Title: "لوازم شخصی",
        },
        {
          Id: 217,
          Title: "سایر",
        },
      ],
    },
    {
      Id: 3,
      Title: "آموزشی",
      Subcategory: [
        {
          Id: 301,
          Title: "زبان‌های خارجی",
        },
        {
          Id: 302,
          Title: "کنکور",
        },
        {
          Id: 303,
          Title: "مدرسه",
        },
        {
          Id: 304,
          Title: "برنامه نویسی",
        },
        {
          Id: 305,
          Title: "محتوای آموزشی",
        },
        {
          Id: 306,
          Title: "سایر",
        },
      ],
    },
    {
      Id: 4,
      Title: "سرگرمی",
      Subcategory: null,
    },
    {
      Id: 5,
      Title: "سلامت و زیبایی",
      Subcategory: null,
    },
    {
      Id: 6,
      Title: "خانه و آشپزخانه",
      Subcategory: null,
    },
    {
      Id: 7,
      Title: "تربیت و روانشناسی",
      Subcategory: null,
    },
    {
      Id: 8,
      Title: "خیریه و مسئولیت اجتماعی",
      Subcategory: null,
    },
    {
      Id: 9,
      Title: "خبری",
      Subcategory: null,
    },
    {
      Id: 10,
      Title: "مذهبی",
      Subcategory: null,
    },
  ],
  min_join_clicks: 7000,
  max_join_clicks: 10000,
  join_click_price: 20000,
  campaign_click_price: 3000,
  campaign_view_price: 40,
  min_sponsored_message_view: 100_000,
  max_sponsored_message_view: 2_000_000,
  sponsored_message_view_price: 140,
  cool_down_milli_second: 100,
  sponsored_message_external_view_price: 140,
  sponsored_message_channel_per_view_price: 140,
  max_views_for_automation: 3000000,
};
